import { Box, LinearProgress, styled } from "@mui/material"

export const TextBold = {
  fontWeight: "500",
}

export const WhiteCard = styled(Box)({
  padding: 20,
  borderRadius: 20,
})

export const WhiteContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
  maxWidth: "480px",
  boxSizing: "border-box",
  backgroundColor: "#F2F3F7",
}

export const TitleContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
}
export const ContentContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  rowGap: "20px",
}

export const ExpensesProgress = styled(LinearProgress)({
  height: 5,
  borderRadius: 50,
  backgroundColor: "#0010521A",
  "& .MuiLinearProgress-bar": {
    borderRadius: 50,
    backgroundColor: "#357BF7",
  },
})
